// extracted by css-extract-rspack-plugin
export default {"analyticsLectureStudent":"WB8nT"};